<script setup>
  import {computed, ref} from "vue";

  import ComponentDialog from "@components/Dialogs/Dialog.vue";

  defineOptions({
    name: "PatientinputClientComponentDeleteDialog",
  });

  const props = defineProps({
    transfer: {
      type: Object,
      default: () => ({}),
    },
  });

  defineEmits(["cancelDelete", "performDelete"]);

  const refDialog = ref(null);

  const firstname = computed(() => props.transfer?.data.masterdata.patient.firstname);

  const lastname = computed(() => props.transfer?.data.masterdata.patient.lastname);

  const birthdate = computed(() => {
    return new Date(props.transfer?.data.masterdata.patient.birthdate).toLocaleDateString("de-DE", {
      dateStyle: "medium",
    });
  });

  const open = () => {
    refDialog.value.open();
  };

  defineExpose({
    open,
  });
</script>

<template>
  <ComponentDialog
    ref="refDialog"
    :dialog-title="
      transfer?.meta?.is_carer ? 'Ausgefüllten Fragebogen Pflege löschen?' : 'Ausgefüllten Patientenfragebogen löschen?'
    "
    primary-label="Löschen"
    :test-id="getTestId('delete')"
    @cancel-button-clicked="$emit('cancelDelete')"
    @primary-button-clicked="$emit('performDelete')"
  >
    <template #content>
      Möchten Sie
      <template v-if="transfer?.meta?.is_carer">den ausgefüllten Fragebogen Pflege für</template>
      <template v-else>den ausgefüllten Patientenfragebogen von</template>
      {{ firstname }} {{ lastname }} (geb. {{ birthdate }}) unwiderruflich löschen?

      <span v-if="transfer.status === 'processed' || transfer.status === 'completed'">
        Die dazugehörige Medikationsanalyse wird nicht gelöscht.
      </span>
    </template>
  </ComponentDialog>
</template>
